import { PayloadAction } from "@reduxjs/toolkit";
import { IInitialState, IExtractList, IExtract, extractSelectedType } from "./Types";

export const Reducer = {
  setExtractList: (state: IInitialState, action: PayloadAction<IExtractList[]>): void => {
    state.extractList = action.payload;
  },
  setViewExtractList: (state: IInitialState, action: PayloadAction<IExtractList[]>): void => {
    state.viewExtractList = action.payload;
  },
  setExtractData: (state: IInitialState, action: PayloadAction<IExtract>): void => {
    state.extractData = action.payload;
  },
  selectedExtract: (state: IInitialState, action: PayloadAction<IExtractList | null>): void => {
    state.selectedExtract = action.payload;
  },
  showExtractReports: (state: IInitialState, action: PayloadAction<boolean>): void => {
    state.showReports = action.payload;
  },
  /**
   * Setting the extract details
   * @param state - state of redux
   * @param action - boolean to send extract details
   */
  setExtractDetailView: (state: IInitialState, action: PayloadAction<boolean>): void => {
    state.showExtractDetails = action.payload;
  },
  /**
   * Setting the opened extract id to fetch extract details
   * @param state - state of redux
   * @param action - action value of extract id
   */
  setSelectedExtractGuid: (state: IInitialState, action: PayloadAction<string>): void => {
    state.selectedExtractGuid = action.payload;
  },
  setSearchText: (state: IInitialState, action: PayloadAction<string>): void => {
    state.searchInput = action.payload;
  },
  /**
   * Setting the extract guid when selected the extract from the list
   * @param state - state to set the value
   * @param action - action to set the value
   */
  setClickedExtractIdDetails: (state: IInitialState, action: PayloadAction<extractSelectedType>): void => {
    state.clickedExtractId = action.payload;
  },

  /**
   * Setting the extract dashboard name
   * @param state - state to set the value
   * @param action - to set the payload value
   */
  setDashBoardName: (state: IInitialState, action: PayloadAction<string>): void => {
    state.dashBoardName = action.payload;
  },

};
